module.exports = __webpack_public_path__ + "static/media/epicode.88cd2c42.jfif";